interface CategoryBadgeProps {
  name: string;
  className?: string;
}

const CATEGORY_COLORS: Record<string, string> = {
  "alertness": "bg-blue-100 text-blue-800",
  "attitude": "bg-purple-100 text-purple-800",
  "safety-and-your-vehicle": "bg-green-100 text-green-800",
  "safety-margins": "bg-yellow-100 text-yellow-800",
  "hazard-awareness": "bg-red-100 text-red-800",
  "vulnerable-road-users": "bg-orange-100 text-orange-800",
  "motorway-rules": "bg-indigo-100 text-indigo-800",
  "rules-of-the-road": "bg-teal-100 text-teal-800",
  "road-and-traffic-signs": "bg-cyan-100 text-cyan-800",
  "documents": "bg-gray-100 text-gray-800",
  "incidents-accidents-and-emergencies": "bg-rose-100 text-rose-800",
  "vehicle-handling": "bg-emerald-100 text-emerald-800",
  "vehicle-loading": "bg-amber-100 text-amber-800",
};

function getColorClass(name: string): string {
  const slug = name.toLowerCase().replace(/\s+/g, "-");
  return CATEGORY_COLORS[slug] || "bg-gray-100 text-gray-800";
}

export default function CategoryBadge({ name, className = "" }: CategoryBadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${getColorClass(name)} ${className}`}
    >
      {name}
    </span>
  );
}
